import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header.component';
import {SlimLoadingBarModule} from 'ng2-slim-loading-bar';
import { DropdownModule } from 'ngx-dropdown';
import { ModalModule } from "ngx-modal";

@NgModule({
  declarations: [
    HeaderComponent
  ],
  imports: [
    BrowserModule,
    SlimLoadingBarModule.forRoot(),
    DropdownModule,
    ModalModule,
    ReactiveFormsModule
  ],
  providers: [],
  bootstrap: [HeaderComponent],
  exports: [HeaderComponent, SlimLoadingBarModule],
})
export class HeaderModule { }



// WEBPACK FOOTER //
// ./src/app/layout/header/header.module.ts